module.exports = __webpack_public_path__ + "static/media/plan-C2b-mobile-sc.d65e68e3.png";